module.exports = __webpack_public_path__ + "img/图像 1.34bba61a.png";